import { render, staticRenderFns } from "./aldehyd.vue?vue&type=template&id=1ed7354d&"
import script from "./aldehyd.vue?vue&type=script&lang=js&"
export * from "./aldehyd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports